<template>
  <MqResponsive target="xs-md">
    <div class="block text-center" style="width: 100%; margin-top: 60px">
      <el-carousel
        height="auto"
        autoplay
        style="width: 100%"
        indicator-position="none"
      >
        <el-carousel-item style="min-height: 113px; width: 100%">
          <img
            src="@/assets/chaojiao/banner1.jpg"
            alt=""
            class="banner-image"
            style="width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
      <!--  -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">SEILECTED ARTICLES</span>
          <div class="line"></div>
        </div>
        <el-row
          :gutter="20"
          style="
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0;
          "
        >
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!-- 交易学院 -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">交易学院</div>
          <span style="font-size: 12px">EXCHANGE SCHOOL</span>
          <div class="line"></div>
        </div>

        <el-row :gutter="10" style="margin-bottom: 20px">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  基础知识
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                交易术语、流程等
              </div>
            </div>

            <img
              src="@/assets/技术分析.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  技术分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                指标、图表形态讲解
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 0px">
                  基本面分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                鷓玘蘺仞Ç喂济数据、政治事件影响
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  交易策略
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                不同风格和风险偏好的策略分享
              </div>
            </div>

            <img
              src="@/assets/即时交易策略.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  视频教学
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                实战演示和讲解
              </div>
            </div>

            <img
              src="@/assets/视频教学.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div text-align:center>期待更多...</div>
          </el-col>
        </el-row>
      </div>
      <!-- 交易大赛 -->
      <div
        style="
          min-width: 412px;
          color: #fff;
          margin-top: 20px;
          box-sizing: border-box;
        "
      >
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">INTRODUCE</span>
          <div class="line"></div>
        </div>
        <el-row
          style="display: flex; flex-direction: column; align-items: center"
        >
          <el-col
            ><div class="grid-content ep-bg-purple" />
            <img style="width: 100%" src="@/assets/16.jpg" alt="Element logo" />
          </el-col>
          <el-col
            style="
              padding: 0 5px;
              text-align: left;
              background: #0f0f0f;
              line-height: 25px;
              height: auto;
              font-size: 12px;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
            ><div class="grid-content ep-bg-purple-light" />

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <el-button
              type="danger"
              size="large"
              style="
                padding: 12px 55px;
                background: #ce0203;
                border: #ce0203;
                width: 60%;
              "
              >查看详情 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!--  -->

      <div
        style="background: #0f0f0f; margin-top: 20px"
        v-for="(item, index) in 2"
        key="index"
      >
        <el-row
          style="
            text-align: left;
            background: #0f0f0f;
            line-height: 25px;
            display: flex;
            align-items: center;
            min-width: 412px;
            padding: 0 10px;
          "
        >
          <el-col :span="5"
            ><div class="grid-content ep-bg-purple" />
            <img
              style="width: 100%"
              src="@/assets/奖杯.png"
              alt="Element logo"
            />
          </el-col>
          <el-col
            style="
              text-align: left;
              line-height: 25px;
              color: #fff;
              font-size: 12px;
              width: 100%;
            "
          >
            <div style="display: flex; align-items: center">
              <div style="font-size: 18px">自由挑战赛(实盘)</div>
              <span
                style="
                  border: 1px solid #d10005;
                  color: #d10005;
                  font-size: 10px;
                  line-height: 16px;
                "
              >
                进行中
              </span>
            </div>
            <div
              style="border-bottom: 1px #4f4f4f solid; width: 100%; height: 1px"
            ></div>
            <p>
              比赛简介:自由实盘挑战赛由冠融科技主办，多家经纪商协办，比赛目的是通过实盘挑战赛方式为操盘手提供展示技术实力和学习
            </p>
            <p>
              周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <div
              style="
                float: right;
                display: flex;
                align-items: center;
                margin-top: 30px;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span style="font-size: 40px">633</span>
                <div>报名人数</div>
              </div>
              <el-button
                type="danger"
                size="large"
                style="
                  background: #ce0203;
                  border: #ce0203;
                  --el-button-size: 23px;
                  font-size: 12px;
                  margin-left: 10px;
                "
                >立即报名 »</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </MqResponsive>
  <!-- 以上手机端 -->
  <MqResponsive target="md+">
    <div style="width: 100%; overflow: hidden">
      <el-carousel style="height: 500px; width: 100%" :autoplay="false">
        <el-carousel-item
          v-for="item in bannerList"
          key="item"
          style="height: 500px; width: 100%"
        >
          <img
            :src="Server.url + item.img_url"
            alt=""
            style="height: 500px; width: 100%"
            class="banner-image"
          />
        </el-carousel-item>
      </el-carousel>

      <el-row
        :gutter="10"
        style="
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          position: relative;
          align-items: end;
          margin-top: 100px;
        "
      >
        <el-col
          :xs="4"
          :sm="6"
          :md="8"
          :lg="8"
          :xl="8"
          style="
            display: flex;
            flex-direction: column;
            text-align: left;
            width: 70%;
            margin-left: 285px;
            padding: 0 25px 0 0;
            box-sizing: border-box;
            margin-top: 20px;
            height: 520px;
          "
        >
          <div class="grid-content ep-bg-purple" />
          <span
            style="font-size: 28px; font-weight: 600; margin-bottom: 20px"
            >{{ lang == "中文" ? introduce.name_cn : introduce.name_en }}</span
          >
          <div
            style="
              font-size: 12px;
              line-height: 1.5;
              height: 320px;
              overflow: auto;
            "
            v-html="
              lang == '中文' ? introduce.content_cn : introduce.content_en
            "
          ></div>
        </el-col>
        <el-col :xs="4" :sm="6" :md="8" :lg="13" :xl="11">
          <div class="grid-content ep-bg-purple-light" />
          <div>
            <img
              src="@/assets/chaojiao/未标题-1.png"
              alt=""
              class="banner-image"
              style="
                width: 100%;
                margin-right: -150px;
                text-align: right;
                position: relative;
                z-index: 5;
                right: 55px;
              "
            />
          </div>
        </el-col>
        <el-col
          :xs="4"
          :sm="6"
          :md="8"
          :lg="16"
          :xl="11"
          style="position: absolute"
        >
          <div class="grid-content ep-bg-purple" />
          <el-row :gutter="150" class="row01">
            <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
              ><div class="grid-content ep-bg-purple" />
              <img
                src="@/assets/chaojiao/名师.png"
                alt=""
                class="banner-image"
                style="width: 50px"
              />
              <div style="width: 200px; margin-top: 10px">
                {{ $t("金融人才教育培训") }}
              </div></el-col
            >
            <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
              ><div class="grid-content ep-bg-purple" />
              <img
                src="@/assets/chaojiao/区域.png"
                alt=""
                class="banner-image"
                style="width: 50px"
              />
              <div style="width: 200px; margin-top: 10px">
                {{ $t("全国各地发展") }}
              </div></el-col
            >
            <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
              ><div class="grid-content ep-bg-purple" />
              <img
                src="@/assets/chaojiao/金融产品.png"
                alt=""
                class="banner-image"
                style="width: 50px"
              />
              <div style="width: 200px; margin-top: 10px">
                {{ $t("各类主流金融产品") }}
              </div></el-col
            >
          </el-row>
        </el-col>
      </el-row>

      <div style="position: relative; margin-top: 100px; padding: 50px 0 0">
        <img
          src="@/assets/chaojiao/背景01.png"
          alt=""
          class="banner-image"
          style="width: 100%"
        />
        <div style="position: absolute; top: 200px; left: 100px">
          <div
            style="
              display: flex;
              flex-direction: column;
              text-align: left;
              line-height: 0.5;
            "
          >
            <span style="font-size: 28px; font-weight: 600; margin-bottom: 20px"
              >COMPANY DEVELOPMENT HISTORY</span
            >
            <span style="font-size: 18px"
              ><span style="color: #4546f8; font-size: 18px">{{
                $t("公司发展历程")
              }}</span></span
            >
          </div>
        </div>
      </div>

      <div
        style="
          background: #f6f6ff;
          height: 600px;
          width: 100%;
          margin-top: -10px;
          padding: 100px 0;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            text-align: left;
            line-height: 1;
            width: 1200px;
            margin: 0 auto;
            justify-content: center;
            align-items: center;
          "
        >
          <span style="font-size: 36px; font-weight: 600; margin-bottom: 20px"
            >MAIN BUSINESS</span
          >
          <span style="font-size: 26px"
            ><span style="color: #4546f8">{{ $t("主营业务") }}</span></span
          >
          <span style="margin-top: 20px"
            >THE PURSUIT OF HIGH EFFICIENCY, HIGH SATISFACTION WITH THE
            SERVICE</span
          >

          <div
            style="
              margin-top: 100px;
              display: flex;
              justify-content: space-between;
              width: 100%;
            "
          >
            <el-link
              :underline="false"
              v-for="(item, index) in data"
              key="index"
              @click="clickBtm(index)"
              ><div
                class="business"
                :class="{ 'business-col': index == indexed }"
              >
                <img :src="item.img" style="width: 70px" />
                <span style="font-size: 20px; font-weight: 600">{{
                  item.name
                }}</span>
                <span style="font-size: 14px">{{ item.desc }}</span>
                <!-- <span style="font-size: 20px; font-weight: 600">01</span> -->
              </div></el-link
            >
          </div>
        </div>
      </div>

      <div
        style="
          width: 100%;
          margin-top: -10px;
          padding: 0 0 0;
          position: relative;
          display: flex;
          justify-content: center;
        "
      >
        <img src="@/assets/chaojiao/背景.png" style="width: 100%" />
        <div
          style="
            display: flex;
            flex-direction: column;
            text-align: left;
            line-height: 1;
            width: 1200px;
            margin: 0 auto;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 100px;
          "
        >
          <span style="font-size: 36px; font-weight: 600; margin-bottom: 20px"
            >OFFLINE FORUM</span
          >
          <span style="font-size: 26px">{{ $t("线下论坛") }}</span>
          <span style="margin-top: 20px"
            >THE PURSUIT OF HIGH EFFICIENCY, HIGH SATISFACTION WITH THE
            SERVICE</span
          >
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 130px;
              position: relative;
            "
          >
            <img
              src="@/assets/chaojiao/期货产业论坛.jpg"
              style="width: 30%; opacity: 0.5"
            />
            <img
              src="@/assets/chaojiao/期货产业论坛.jpg"
              style="width: 30%; opacity: 0.5"
            />
            <div
              style="
                position: absolute;
                width: 100%;
                display: flex;
                justify-content: center;
                top: -76px;
              "
            >
              <img
                src="@/assets/chaojiao/常规金融论坛.jpg"
                style="
                  width: 50%;
                  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1),
                    -5px -5px 10px rgba(0, 0, 0, 0.1);
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          width: 100%;
          margin-top: -10px;
          padding: 0 0 0;
          position: relative;
          display: flex;
          justify-content: center;
        "
      >
        <img src="@/assets/chaojiao/背景.png" style="width: 100%" />
        <div
          style="
            display: flex;
            flex-direction: column;
            text-align: left;
            line-height: 1;
            width: 1200px;
            margin: 0 auto;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 100px;
          "
        >
          <span style="font-size: 36px; font-weight: 600; margin-bottom: 20px"
            >OFFLINE LECTURE</span
          >
          <span style="font-size: 26px">{{ $t("线下讲座") }}</span>
          <span style="margin-top: 20px"
            >THE PURSUIT OF HIGH EFFICIENCY, HIGH SATISFACTION WITH THE
            SERVICE</span
          >
          <span
            style="
              font-size: 14px;
              font-weight: 600;
              color: #26358a;
              margin: 40px 0 30px;
            "
            >{{ $t("线下讲座行程表如下") }}</span
          >

          <div
            style="
              width: 100%;
              padding: 30px;
              box-sizing: border-box;
              border: 1px dashed #ccc;
              border-radius: 20px;
            "
          >
            <el-descriptions
              class="margin-top"
              :column="4"
              :size="size"
              border
              style="width: 100%"
              v-for="item in dataList"
              key="item"
            >
              <el-descriptions-item width="100">
                <template #label>
                  <div class="cell-item">时间 Time</div>
                </template>
                {{ item.activity_time }}
              </el-descriptions-item>
              <el-descriptions-item width="160">
                <template #label>
                  <div class="cell-item">{{ $t("项目名称") }}</div>
                </template>
                {{ item.name_cn }}
              </el-descriptions-item>
              <el-descriptions-item width="160">
                <template #label>
                  <div class="cell-item">{{ $t("项目名称") }}</div>
                </template>
                {{ item.name_en }}
              </el-descriptions-item>
              <el-descriptions-item width="160">
                <template #label>
                  <div class="cell-item">{{ $t("人数") }}</div>
                </template>
                <el-tag size="small">{{ item.max_participants }}</el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 180px;
              justify-content: space-around;
              margin-top: 30px;
              font-size: 14px;
              font-weight: 600;
              color: #26358a;
            "
          >
            <span>{{ $t("每月初定时更新安排") }}</span>
            <img src="@/assets/chaojiao/了解更多.jpg" style="width: 30%" />
            <span>{{ $t("关注公众号了解更多") }}</span>
          </div>
        </div>
      </div>

      <div
        style="
          width: 100%;
          margin-top: -10px;
          padding: 0 0 0;
          position: relative;
          display: flex;
          justify-content: center;
        "
      >
        <img
          src="@/assets/chaojiao/背景1.png"
          style="width: 100%; height: 800px"
        />
        <div
          style="
            display: flex;
            flex-direction: column;
            text-align: left;
            line-height: 1;
            width: 1200px;
            margin: 0 auto;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 100px;
            color: #fff;
          "
        >
          <span style="font-size: 36px; font-weight: 600; margin-bottom: 20px"
            >COOPERATIVE ENTERPRISE</span
          >
          <span style="font-size: 26px">{{ $t("合作企业") }}</span>
          <span style="margin-top: 20px"
            >THE PURSUIT OF HIGH EFFICIENCY, HIGH SATISFACTION WITH THE
            SERVICE</span
          >

          <div
            style="
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              margin-top: 60px;
            "
          >
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/1.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/2.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/3.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/4.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/5.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/6.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/7.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/8.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/9.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/10.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/11.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/12.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/13.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/14.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/15.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/16.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/17.png" style="width: 100%" />
              </div>
            </div>
            <div class="hexagon">
              <div class="hexagon-content">
                <img src="@/assets/chaojiao/18.png" style="width: 100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
      style="
        width: 100%;
        margin-top: -10px;
        padding: 0 0 0;
        position: relative;
        display: flex;
        justify-content: center;
        height: ;
      "
    >
      <img src="@/assets/chaojiao/背景2.png" style="width: 100%" />
      <div
        style="
          display: flex;
          flex-direction: column;
          text-align: left;
          line-height: 0.5;
          width: 1200px;
          margin: 0 auto;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 120px;
          color: #fff;
        "
      >
        <img src="@/assets/logo/logo.png" style="width: 20%" />
        <span style="font-size: 46px; margin: 60px 0 40px">{{
          $t("欢迎联系我们")
        }}</span>
        <span style="font-size: 24px">{{ $t("联系电话") }}:183-1009-0624</span>
        <span style="font-size: 24px; margin-top: 24px"
          >{{ $t("联系电话") }}:173-7213-7306</span
        >

        <div style="display: flex; margin-top: 80px">
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 280px;
              margin-top: 30px;
              font-size: 14px;
              justify-content: space-around;
              font-size: 24px;
            "
          >
            <span>李定潮</span>
            <img src="@/assets/chaojiao/了解更多.jpg" style="width: 80%" />
            <span>{{ $t("电话") }}:18310090624</span>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 280px;
              margin-top: 30px;
              font-size: 14px;
              color: #fff;
              justify-content: space-around;
              font-size: 24px;
            "
          >
            <span>客服晓云</span>
            <img src="@/assets/chaojiao/了解更多.jpg" style="width: 80%" />
            <span>{{ $t("电话") }}:15677134167</span>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 280px;
              margin-top: 30px;
              font-size: 14px;
              color: #fff;
              justify-content: space-around;
              font-size: 24px;
            "
          >
            <span>甘翠静</span>
            <img src="@/assets/chaojiao/了解更多.jpg" style="width: 80%" />
            <span>{{ $t("电话") }}:17372137306</span>
          </div>
        </div>
      </div>
    </div> -->
    </div>
  </MqResponsive>
  <div><Footer /></div>
</template>

<script setup>
import Footer from "../Footer";
import { reactive, ref } from "vue";
import MyServerHttp from "../../plugins/http.js";
import Server from "../../plugins/server.js";
import apiServe from "../../plugins/api.js";
import { onMounted, onUnmounted } from "vue";

let lang = ref("");
if (!localStorage.getItem("lang")) {
  lang = "中文";
} else {
  lang = localStorage.getItem("lang");
}

const bannerHeight = ref(700); // 默认高度
const handleResize = () => {
  if (window.innerWidth < 768) {
    bannerHeight.value = 200; // 小屏幕高度
  } else if (window.innerWidth < 1024) {
    bannerHeight.value = 300; // 中等屏幕高度
  } else {
    bannerHeight.value = 700; // 大屏幕高度
  }
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize(); // 初始化时也调用一次以设置正确的高度
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
let introduce = ref({});
const getdatas = async () => {
  const data = reactive({
    keyword: "",
    status: "",
    page: 1,
    limit: 15,
  });
  try {
    const response = await MyServerHttp.post(apiServe.aboutUsList, data);
    introduce.value = response.data.datas.list[0];
    console.log(introduce.value, "+++++++++++++++++++++++++++++9");
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
getdatas();
// 轮播图
const bannerList = ref([]);
const getList = async () => {
  const data = reactive({
    keyword: "",
    status: "",
    page: 1,
    limit: 15,
  });
  try {
    const response = await MyServerHttp.post(apiServe.carouselList, data);

    bannerList.value = response.data.datas.list;
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
getList();
// ++++++++
const activeName = ref("1");
let indexed = ref("0");
const clickBtm = (num) => {
  indexed.value = num;
};

const handleClick = (tab, event) => {
  console.log(tab, event);
};

const data = [
  {
    desc: "经纪业务:为金融持牌机构、公司提供经纪业务，促成不同业务领域的合作与",
    name: "期权课程",
    img: require("@/assets/chaojiao/主营业务/3.png"),
  },
  {
    desc: "培训业务:我们提供有偿股票/期货/期权培训服务，与金融老师合作，提升你",
    name: "股票课程",
    img: require("@/assets/chaojiao/主营业务/2.png"),
  },
  {
    desc: "期货课程期货交易是一种利用价格波动来获取收盒的金融活动，它涉及到各",
    name: "期货课程",
    img: require("@/assets/chaojiao/主营业务/1.png"),
  },
  {
    desc: "如果你励志在金融投教行业发展、如果你的图队/公司没有好的项目、如果你",
    name: "线下俱乐部",
    img: require("@/assets/chaojiao/主营业务/4.png"),
  },
  {
    desc: "《超级交易员论坛,走私募》作为普通投资者和私募公司之间的桥梁，勇于做",
    name: "走访私募",
    img: require("@/assets/chaojiao/主营业务/5.png"),
  },
  {
    desc: "如何联系我们",
    name: "开戶业务",
    img: require("@/assets/chaojiao/主营业务/6.png"),
  },
];

const total = ref("");
const dataList = ref({});
const dataForm = reactive({
  category_id: "8",
  page: 1,
  limit: 15,
});
const getForumlist = async () => {
  try {
    const response = await MyServerHttp.post(apiServe.activityList, dataForm);
    dataList.value = response.data.datas.list;
    total.value = bannerList.value.length;
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
getForumlist();
</script>

<style lang="less" scoped>
.text-center {
  overflow-y: hidden;
}

.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  display: flex;
  align-items: center;
  margin: 0;
  text-align: center;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 1200px;
  margin: 80px auto 0;
  color: #fff;

  div {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    line-height: 0px;
  }
  span {
    font-size: 16px;
  }
  .line {
    width: 80%;
    height: 1px;
    background: #8d0100;
    margin: 10px auto 30px;
  }
}

/deep/.el-table th.el-table__cell {
  background-color: var(--el-table-header-bg-color);
  background: #910101;
  border-bottom: none;
}
/deep/.el-table tr {
  background-color: var(--el-table-tr-bg-color);
  background: black;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: var(--el-fill-color-lighter);
  background: #1c1c1c;
}
/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

/deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none;
  /* border-left: 1px solid var(--el-border-color-light); */
  transition: color var(--el-transition-duration)
      var(--el-transition-function-ease-in-out-bezier),
    padding var(--el-transition-duration)
      var(--el-transition-function-ease-in-out-bezier);
  width: 120px;
}

/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  box-sizing: border-box;
  border: none;
  background: #f5f6fa;
  border-radius: 30px;
}
/deep/.el-tabs__nav-next,
.el-tabs__nav-prev {
  color: var(--el-text-color-secondary);
  cursor: pointer;
  font-size: 12px;
  line-height: 44px;
  position: absolute;
  text-align: center;
  width: 0;
  display: none;
}
/deep/.el-tabs__nav-next,
.el-tabs__nav-prev {
  color: var(--el-text-color-secondary);
  cursor: pointer;
  font-size: 12px;
  line-height: 44px;
  position: absolute;
  text-align: center;
  display: none !important;
}
/deep/.el-tabs--card > .el-tabs__header {
  border: none;
  height: var(--el-tabs-header-height);
}

/deep/.el-tabs__item.is-active,
.el-tabs__item:hover {
  /* color: var(--el-color-primary); */
  background: #535353;
  color: #fff;
  border-radius: 30px;
}

.el-link {
  --el-link-font-size: var(--el-font-size-base);
  --el-link-font-weight: var(--el-font-weight-primary);
  /* --el-link-text-color: var(--el-text-color-regular); */
  /* --el-link-hover-text-color: var(--el-color-primary); */
  /* --el-link-disabled-text-color: var(--el-text-color-placeholder); */
  align-items: center;
  color: var(--el-link-text-color);
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  font-size: var(--el-link-font-size);
  font-weight: var(--el-link-font-weight);
  justify-content: center;
  outline: none;
  padding: 0;
  position: relative;
  text-decoration: none;
  vertical-align: middle;
}
.business {
  background: #fff;
  height: 350px;
  width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  box-sizing: border-box;
  justify-content: space-between;
}
.business-col {
  color: #fff;
  background-image: url("@/assets/chaojiao/期权.png");
  background-size: cover; /* 或者使用 100% 100% */
  background-position: center; /* 确保图片居中 */
  background-repeat: no-repeat; /* 防止图片重复 */
}

.hexagon {
  position: relative;
  width: 100px;
  height: 57.7px; /* sqrt(3) / 2 * width */
  background-color: #999;
  margin: 28.8px 0; /* 1/2 * height */
}

.hexagon {
  width: 130px;
  height: 130px;
  background-color: #fff;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.hexagon-content {
  width: 80%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
}

.el-carousel__item {
  height: auto;
}
.row01 {
  background: #3b3b3b;
  padding: 10px 30% 10px 30%;
  width: 150%;
  bottom: 5px;
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  color: #fff;
  font-size: 12px;
  box-sizing: border-box;
  .el-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
}

/deep/.el-carousel__item[data-v-df660e5c]:nth-child(2n + 1) {
  background-color: rgba(0, 0, 0, 0);
}
</style>
